<template>
   <b-modal
   v-model="state"
   centered
   title="Händlerbestand sperren"
   @ok="toggle()"
   >
      <span v-if="mode =='create'">
         Wollen sie wirklich eine bestandsspezifische Blockierung erstellen?<br>
         Der Bestand wird auf 0 gesetzt.
      </span>
      <span v-else>
         Wollen Sie wirklich die bestandsspezifische Blockierung aufheben?
      </span>
      <template v-if="mode =='delete'" #modal-footer="{  hide }" >
         <!-- Emulate built in modal footer ok and cancel button actions -->
         <b-button size="md" variant="outline-secondary" @click="hide('forget')">
            Abbrechen
         </b-button>
         <b-button size="md" variant="danger" @click="toggle()">
            Blockierung löschen
         </b-button>
      </template>
        
   </b-modal>
</template>
<script>
export default {
   props :{
      passedStock:{
         type: Object,
         default: null,
      },
      openVendorStockBlockModal:{
         type: Boolean,
         default: false,
      }
   },

   data(){
      return{         
         state: false,
         stock: null,
         mode: 'neutral',
      }
   },
   methods:{
      /*
      abort() {
         this.state = false;
         this.stock = null;
         this.mode = 'neutral';
         this.$emit('closedVendorStockBlock');
      },*/
      reset() {
         this.state = false;
         this.mode = 'neutral';
         this.$emit('closedVendorStockBlock');
      },
      open(stock) {
         this.stock = stock;
         this.mode = (stock.vendorStockBlock) ? 'delete' : 'create';
         this.state = true;
      },
      toggle() // used both for create and delete
      {
         //this.stock = this.passedStock;

         if(this.stock.vendorStockBlock === false){
            this.mode = 'create'
         } else {
            this.mode = 'delete'
         }

         let payload = {
            stockId: this.stock.id,
            vendorId: this.stock.vendorId,
            materialId: this.stock.materialId,
            sku: this.stock.sku,
            mode: this.mode
         }

         // console.log(payload);
         // console.log(this.stock);

         axios.post( '/material/toggle_vendor_stock_block', payload ).then( response => {
            console.log(response.data);
            let mode = response.data.mode;

            if(mode == 'created')
            {
               this.stock.vendorStockBlock = true;
               this.stock.quantity = 0;
               this.emit_updateStock(response.data.processedStockIds, mode)
               this.reset();
            }
            else if(mode == 'deleted')
            {
               this.stock.vendorStockBlock = false
               this.emit_updateStock(response.data.processedStockIds, mode)              
               this.reset();
            }

         }).catch( error => {
            console.log(error);
            this.emit_error('VendorStockBlock', error.response?.data, error.message);
         });
      },
      emit_updateStock(stockIds, mode){
			this.$emit('updateStock', stockIds, mode);
		},
      emit_error(title='', error='', message=''){
         this.$emit('error', title, error, message)
      }
   },
   watch :{
      openVendorStockBlockModal: function(newVal, oldVal){
         if(newVal === true){
            this.open(this.passedStock)
         }
      }
   }
}
</script>